// 从 saas-editor/src/labelAction/view/labelAction.tsx 搬迁
import classNames from 'classnames';
import React from 'react';
import './index.less';

interface LabelActionProps {
    title: string;
    children?: React.ReactNode;
    // 是否左右对齐
    align?: boolean;
    // 是否垂直布局
    vertical?: boolean;
    style?: React.CSSProperties;
}

const LabelAction = React.forwardRef<HTMLDivElement, LabelActionProps>((props, ref) => {
    const { title, children, align = false, vertical = false, style } = props;
    return (
        <div
            ref={ref}
            className={classNames(
                'label-action',
                { 'label-action-align': align },
                { 'label-action-vertical': vertical },
            )}
            style={style}
        >
            <div className="label-action__title">{title}</div>
            <div className="label-action__content">{children}</div>
        </div>
    );
});

export default React.memo(LabelAction);
